module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("6rIAR"))).then(() => parcelRequire('kBvfX'));